export enum CourseListTypeEnum {
  Recommended = 'recommended',
}
